import React, { Fragment, useState } from 'react'
import ModalHeader from 'reactstrap/lib/ModalHeader'
import ModalBody from 'reactstrap/lib/ModalBody'
import Modal from '../components/Modals/Modal'
import '../common/HelpModal.scss'
import email from '../../img/email.png'
import screenMonCompte from '../../img/screen-moncompte.png'
import eticket from '../../img/eticket.png'
import ticket from '../../img/ticket-magasin.png'
import { useTranslator } from '../../hooks'

const HelpButton = () => {
  const [modal, setModal] = useState(false)
  const translator = useTranslator()

  const toggle = () => setModal(!modal)

  return (
    <Fragment>
      <span className={'info'} onClick={toggle}>
        ?
      </span>
      <Modal isOpen={modal} toggle={toggle} className="HelpModal" size="lg">
        <ModalHeader tag={'p'} toggle={toggle}>
          <strong
            dangerouslySetInnerHTML={{
              __html: translator('help.modal.title'),
            }}
          />
        </ModalHeader>
        <ModalBody>
          <ul className="ul">
            <li
              className="mb-4"
              dangerouslySetInnerHTML={{
                __html: translator('help.modal.message1'),
              }}
            />
            <li>
              <span
                dangerouslySetInnerHTML={{
                  __html: translator('help.modal.message2'),
                }}
              />
              <ul>
                <li
                  dangerouslySetInnerHTML={{
                    __html: translator('help.modal.message3'),
                  }}
                />
                <li
                  dangerouslySetInnerHTML={{
                    __html: translator('help.modal.message4'),
                  }}
                />
                <li
                  dangerouslySetInnerHTML={{
                    __html: translator('help.modal.message5'),
                  }}
                />
              </ul>
            </li>
          </ul>
          <img src={email} alt="" />
          <ul className="list-style-none ul">
            <li>
              <ul>
                <li
                  dangerouslySetInnerHTML={{
                    __html: translator('help.modal.message6'),
                  }}
                />
              </ul>
            </li>
          </ul>
          <img src={screenMonCompte} alt="" />
          <ul className="ul">
            <li
              dangerouslySetInnerHTML={{
                __html: translator('help.modal.message7'),
              }}
            />
          </ul>
          <img src={eticket} alt="" />
          <ul className="ul">
            <li
              dangerouslySetInnerHTML={{
                __html: translator('help.modal.message8'),
              }}
            />
          </ul>
          <img src={ticket} alt="" />
        </ModalBody>
      </Modal>
    </Fragment>
  )
}

export default HelpButton
